<template>
  <div>
    <vue-page-transition name="fade">
      <div v-if="isCallApi">
        <div class="container">
          <div class="loader"></div>
          <div class="loader"></div>
          <div class="loader"></div>
        </div>
        <p class="text-center mb-3 font-semibold font-sans text-xl text-gray-400">Đang tải dữ liệu...</p>
      </div>
    </vue-page-transition>
    <div class="footer-logo relative z-50 text-[#7D8600] font-sans" :class="{'fade-logo' : fadeLogo}">
      <div class="flex" style="align-items: center;">
        <img class="w-20" src="@/assets/img/logo.png" alt="Logo">
        <h6 class="text-6xl mb-0 font-extrabold h-fit">HUET</h6>
      </div>
      <h1 class="text-center w-max font-extrabold text-2xl">Khoa Kỹ Thuật & Công Nghệ</h1>
      <h1 class="text-center w-max font-extrabold text-2xl">Đại học Huế</h1>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCallApi: false,
      fadeLogo: false,
    }
  },
  created() {
    this.fadeLogo = true
    setTimeout(()=>{
      this.isCallApi = true
    },3000)
  }
}
</script>

<style scoped>
.footer-logo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.fade-logo {
  animation: fadeOut 3s ease-in-out forwards;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  width: 160px;
  height: 100px;
  margin-left: -80px;
  margin-top: -50px;
  border-radius: 5px;
  background: #1e3f57;
  animation: dot1_ 3s cubic-bezier(0.55,0.3,0.24,0.99) infinite;
}

.loader:nth-child(2) {
  z-index: 11;
  width: 150px;
  height: 90px;
  margin-top: -45px;
  margin-left: -75px;
  border-radius: 3px;
  background: #3c517d;
  animation-name: dot2_;
}

.loader:nth-child(3) {
  z-index: 12;
  width: 40px;
  height: 20px;
  margin-top: 50px;
  margin-left: -20px;
  border-radius: 0 0 5px 5px;
  background: #6bb2cd;
  animation-name: dot3_;
}

@keyframes dot1_ {
  3%,97% {
    width: 160px;
    height: 100px;
    margin-top: -50px;
    margin-left: -80px;
  }

  30%,36% {
    width: 80px;
    height: 120px;
    margin-top: -60px;
    margin-left: -40px;
  }

  63%,69% {
    width: 40px;
    height: 80px;
    margin-top: -40px;
    margin-left: -20px;
  }
}

@keyframes dot2_ {
  3%,97% {
    height: 90px;
    width: 150px;
    margin-left: -75px;
    margin-top: -45px;
  }

  30%,36% {
    width: 70px;
    height: 96px;
    margin-left: -35px;
    margin-top: -48px;
  }

  63%,69% {
    width: 32px;
    height: 60px;
    margin-left: -16px;
    margin-top: -30px;
  }
}

@keyframes dot3_ {
  3%,97% {
    height: 20px;
    width: 40px;
    margin-left: -20px;
    margin-top: 50px;
  }

  30%,36% {
    width: 8px;
    height: 8px;
    margin-left: -5px;
    margin-top: 49px;
    border-radius: 8px;
  }

  63%,69% {
    width: 16px;
    height: 4px;
    margin-left: -8px;
    margin-top: -37px;
    border-radius: 10px;
  }
}
</style>